import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { KeplerDataQuestionsService } from '../../questions-service/kepler-data-questions.service';
import { KeplerService } from '../../services/kepler.service';
import { EmitterService } from 'core/services';
import { KeplerMatch } from '../../models/KeplerMatch';
import { Subscription } from 'rxjs';
import { DynamicFormComponent } from 'core/components';
import { Client } from 'core/models/client';

@Component({
  selector: 'lms-kepler-editor',
  templateUrl: './kepler-editor.component.html',
  styleUrls: ['./kepler-editor.component.scss']
})
export class KeplerEditorComponent implements OnInit, OnDestroy {
  @ViewChild('keplerForm', { static: true }) private keplerForm: DynamicFormComponent;
  @Input() public client: Client;
  @Input() public keplerMatch?: KeplerMatch;
  @Output() public submit: EventEmitter<Object> = new EventEmitter<Object>();
  @ViewChild('translationModal', { static: false }) translationModal: any;
  public data: any = {};
  private routeSubscription: Subscription = new Subscription();
  private keplerMatchSubscription: Subscription = new Subscription();

  constructor(public keplerDataQuestionsService: KeplerDataQuestionsService, private keplerService: KeplerService) {}

  public ngOnInit(): void {
    EmitterService.get('translateKeplerKpi').subscribe((data) => {
      if (data) this.translationModal.openModal(data);
    });
  }

  public ngOnChanges(): void {
    this.data = { keplerMatch: this.keplerMatch, client: this.client };
  }

  public onSubmit(keplerData: any): void {
    if (this.keplerMatch) {
      this.onUpdate(keplerData);
    } else {
      this.onCreate(keplerData);
    }
  }

  confirmTranslation(translation: any) {
    this.keplerDataQuestionsService.updateKpisTranslations(translation);
  }

  onCreate(keplerData: any) {
    this.keplerService
      .create(keplerData)
      .then((keplerDataResp) => {
        this.submit.emit(keplerDataResp);
        this.keplerForm.submitted(null);
      })
      .catch((error) => {
        this.keplerForm.submitted(error);
      });
  }

  onUpdate(keplerData: any) {
    this.keplerService
      .update({ id: this.data['keplerMatch']['id'], ...keplerData })
      .then((updatedMatch) => {
        this.submit.emit(updatedMatch);
        this.keplerForm.submitted(null);
      })
      .catch((error) => {
        this.keplerForm.submitted(error);
      });
  }

  public ngOnDestroy(): void {
    this.keplerMatchSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }
}
